import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ListaUsuariosPaginada  } from '../../components/PanelControl'
import { sagaGetNuevosUsuarios, sagaHabilitarUsuario } from '../../reducers/usuarioReducer/actions'
import { NuevosUsuariosSelector, UsuarioHabilitadoSelector } from '../../selectors/usuarioSelector'

class ContainerNuevosUsuarios extends React.Component{

    constructor(props){
        super(props)

        this.state={
            openModalHabilitar: false,
            usuario: null,
        }
        
        props.sagaGetNuevosUsuarios(1);/** toma la pagina 1 */
    }

    componentWillReceiveProps = (nextProps) => {
        console.log(nextProps)
    }

    render() {
        return <ListaUsuariosPaginada  
        titulo="Usuarios no habilitados"
        tipo="usuariosNuevos"
        usuarios={this.props.usuariosNuevos}
        mapToItem={(x)=>({
            usuario:x.nombreUsuario, 
            nombre:x.nombre + " " + x.apellido, 
            razonSocial:x.razonSocial, 
            cuit:x.cuit,
            opciones:[{nombre:"Habilitar usuario",handler:()=>{this.setState({openModalHabilitar:true, usuario:{id: x.id, nombre: x.nombreUsuario}})}}],
            imagen:(x.imagen)?x.imagen:require('../../images/ExternalUser.png'),
        })}
        openModal={this.state.openModalHabilitar}
        handleCloseModal={()=>{
            this.setState({openModalHabilitar:false})
        }}
        resultadoAccion = {this.props.usuarioHabilitadoResult}
        mensajeAccion={"Usuario habilitado"}
        handleOnPagination= {(page)=>{this.props.sagaGetNuevosUsuarios(page)}}
        pedido={this.state.usuario?{idPedido: this.state.usuario.id, nombreUsuario: this.state.usuario.nombre}:{}}
        handleEliminar={(id)=>{
            this.props.sagaHabilitarUsuario(id, this.props.usuariosNuevos.currentPage)
            this.setState({openModalHabilitar:false})
        }}
        />
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        sagaGetNuevosUsuarios,
        sagaHabilitarUsuario
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        usuariosNuevos: NuevosUsuariosSelector(state),
        usuarioHabilitadoResult: UsuarioHabilitadoSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ContainerNuevosUsuarios)